import { useState, useEffect } from "react";
import { getSenatorList, getRegions } from "../../../../../api/ph-api";
import SenatorialWidget from "../../../../../../components/SenatorialWidget";

export const getStaticProps = async () => {
  let regionList = await getRegions();
  let senatorialList = await getSenatorList();

  return {
    props: { senatorialList, regionList },
    revalidate: 5,
  };
};

const EmbedSenatorOfficialResults = ({ senatorialList, regionList }) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(
      `${window.location.origin}/elections/2022/races/senator/official-results`
    );
  }, []);

  return (
    <SenatorialWidget
      view={"official-results"}
      withCollapse={false}
      regionList={regionList?.results}
      senatorialList={senatorialList}
      urlPath="/elections/2022/candidates/"
      url={url}
      isEmbed={true}
    />
  );
};

export default EmbedSenatorOfficialResults;
